import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { yupResolver } from '@hookform/resolvers/yup'

import Radio from '../../../../components/UI/Radio'
import { Button } from '../../../../components/UI'
import ErrorMessageWithExclamation from '../../../../components/UI/ErrorMessageWithExclamation'

import { selectUserData } from '../../../../routing/fetchingfunction/user/user.reducer'
import { setStep, updateAbout } from '../../../../routing/fetchingfunction/user/user.action'

import { ProfileSecurityScheme } from '../../../../routing/utils/validators'

import { displayLastNameOptions, displayNameOptions } from '../../../../constants'

const ProfileSecurity = () => {
  const dispatch = useDispatch()

  const userData = useSelector(selectUserData)

  const {
    formState: { errors },
    handleSubmit,
    register,
  } = useForm({
    defaultValues: {
      display_name: userData?.profile?.display_name || '',
      display_last_name: userData?.profile?.display_last_name || '',
    },
    resolver: yupResolver(ProfileSecurityScheme),
  })

  const [isLoading, setIsLoading] = useState(false)

  const handleFormSubmit = (data) => {
    setIsLoading(true)

    dispatch(
      updateAbout({
        id: userData.id || userData.pk,
        profile: {
          ...userData.profile,
          ...data,
        },
      })
    )
      .then((data) => {
        if (!data.error) {
          dispatch(setStep(1))
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const displayNameOptionsContent = displayNameOptions.map((displayNameOption) => {
    return (
      <label
        key={displayNameOption.value}
        className="w-full md:flex-1 cursor-pointer h-[44px] px-[14px] shadow-button rounded-[8px] border-[#FFCA84] border-[1px] bg-white flex items-center"
      >
        <Radio value={displayNameOption.value} {...register('display_name')} />

        <span className="text-sm md:text-base font-normal text-primary-100 ml-[8px] select-none break-words">
          {' '}
          {displayNameOption.label}
        </span>
      </label>
    )
  })

  const displayLastNameOptionsContent = displayLastNameOptions.map((displayLastNameOption) => {
    return (
      <label
        key={displayLastNameOption.value}
        className="w-full md:w-auto cursor-pointer h-[44px] px-[14px] shadow-button rounded-[8px] border-[#FFCA84] border-[1px] bg-white flex items-center"
      >
        <Radio value={displayLastNameOption.value} {...register('display_last_name')} />

        <span className="text-base font-normal text-primary-100 ml-[8px] select-none">
          {displayLastNameOption.label}
        </span>
      </label>
    )
  })

  return (
    <div className="mt-[20px] bg-[#FEEBDD] rounded-lg p-8">
      <h4 className="text-base text-primary-100 font-bold">Profile Security</h4>

      <form
        className="mt-[20px] border-[1px] border-solid border-[#FFCA84] rounded-lg p-[20px] gap-y-[24px] flex flex-col"
        onSubmit={handleSubmit(handleFormSubmit)}
      >
        <div className="max-w-[464px] w-full">
          <span className="inline-block text-base font-semibold text-primary-100 mb-[4px]">
            How would you like to display your name in your profile?
          </span>

          <div className="w-full flex items-center gap-x-[16px]">{displayNameOptionsContent}</div>

          {errors.display_name && (
            <ErrorMessageWithExclamation text={errors.display_name.message} />
          )}
        </div>

        <div className="w-full">
          <span className="inline-block text-base font-semibold text-primary-100 mb-[4px]">
            How would you like to display your last name in your profile?
          </span>

          <div className="w-full flex flex-col md:flex-row gap-y-[12px] md:gap-x-[16px] mt-2">
            {' '}
            {displayLastNameOptionsContent}
          </div>

          {errors.display_last_name && (
            <ErrorMessageWithExclamation text={errors.display_last_name.message} />
          )}
        </div>

        <Button
          type="submit"
          className="w-fit min-w-[129px] !text-sm !font-semibold"
          isLoading={isLoading}
        >
          Save Changes
        </Button>
      </form>
    </div>
  )
}

export default ProfileSecurity
